import React from 'react';
import {
  Dialog,
  DialogContent,
  Typography,
  Link,
  TextField,
  DialogActions,
  Button,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import api from '../../services/api';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useStyles } from '../../components/Styles';
import { contactUsPhone } from 'utils/consts';
import './styles.css';

function DialogForgotPass(props) {
  const [openDialogMsg, setOpenDialogMsg] = React.useState(false);
  const [openDialogPrimary, setOpenDialogPrimary] = React.useState(true);
  const classes = useStyles();

  async function handleEmail(e) {
    try {
      await api.get('/users/forgotpass', {
        params: { email: formik.values.email },
      });
      setOpenDialogPrimary(true);
      setOpenDialogMsg(true);
    } catch (err) {
      alert('Erro no envio do email! Tente novamente');
    }
  }

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email('Insira um email valido')
        .required('Campo Obrigatório'),
    }),
    onSubmit: (values) => {
      handleEmail(values);
    },
  });

  return (
    <header>
      <Dialog open={openDialogPrimary} classes={{ width: '1000px' }}>
        <CloseIcon
          fontSize="large"
          onClick={props.close}
          style={{
            cursor: 'pointer',
            position: 'absolute',
            right: '1rem',
            top: '1rem',
            width: '25px',
          }}
        >
          X
        </CloseIcon>
        <DialogContent
          style={{
            display: 'flex',
            flexDirection: 'column',
            // alignItems: "center",
            justifyContent: 'space-between',
            padding: '5rem',
          }}
        >
          <div>
            <div
              style={{
                fontWeight: 'bold',
                marginBottom: '2rem',
                textAlign: 'center',
              }}
            >
              <Typography
                variant="h5"
                component="span"
                style={{ fontWeight: 'bold' }}
              >
                RECUPERAR SENHA
              </Typography>
            </div>

            <Typography variant="subtitle2" style={{ color: '#000000' }}>
              Insira o endereço de e-mail associado à sua conta Greenfy.
            </Typography>
            <form onSubmit={formik.handleSubmit}>
              <TextField
                autoFocus
                variant="outlined"
                margin="dense"
                id="email"
                label="Email"
                type="email"
                fullWidth
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={!!(formik.touched.email && formik.errors.email)}
                helperText={
                  formik.touched.email
                  && formik.errors.email
                  && formik.errors.email
                }
              />
            </form>

            {openDialogMsg && (
              <Typography
                style={{
                  color: '#2C9864',
                  fontWeight: '700',
                  marginBottom: '1rem',
                }}
              >
                Verifique a sua caixa de e-mail e SPAM acabamos de enviar um
                link para recuperar seu e-mail.
              </Typography>
            )}

            <DialogActions style={{ padding: '15px 0px 15px 0px' }}>
              <Button
                style={{ borderRadius: '20px' }}
                className={classes.buttonRegister}
                onClick={formik.handleSubmit}
                fullWidth
              >
                Enviar
              </Button>
            </DialogActions>
          </div>
          <Typography style={{ marginBlock: '10px' }} variant="subtitle2">
            Seu endereço de e-mail foi alterado?
          </Typography>
          <Typography variant="subtitle2">
            Se você não usa mais o endereço de e-mail associado a sua conta
            Greenfy, entre em contato com o
            <Link
              href={`https://api.whatsapp.com/send?phone=${contactUsPhone}&text=Ol%C3%A1!%20Gostaria%20de%20mais%20informa%C3%A7%C3%B5es%20sobre...`}
              target="_blank"
              rel="noopener"
              style={{ color: '#1572c6' }}
            >
              {' Atendimento ao Cliente '}
            </Link>
            para ajudar a recuperar o acesso á sua conta .
          </Typography>
        </DialogContent>
      </Dialog>
    </header>
  );
}

export default DialogForgotPass;
